import { useEffect } from 'react';
import styles from './AppAds.module.css';

const APP_ADS_RECORD = 'google.com, pub-7394113567914956, DIRECT, f08c47fec0942fa0';

export default function AppAds() {
    useEffect(() => {
        document.title = 'app-ads.txt';
    }, []);

    return <pre className={styles.record}>{APP_ADS_RECORD}</pre>;
}
